import React, { FC, ChangeEvent } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PropertyTypeRadioButtonWrapper } from '../../../search/common/Dropdown.styles';
import { updateFilter, propertyTypeSelector } from '../../../reducers/filters';
import { getTranslator } from '../../i18n/getTranslator';
import { FilterOptions } from '../../../reducers/filters.types';
import {
    PropertyTypeRadio,
    FilterWrapper,
    PropertyTypeFilterLabel
} from './SearchInitiationMobile.styles';
import searchTranslations from 'public/locales/en/search.json';
import { StyledRadio } from './SearchInitiationMobile.styles';

const t = getTranslator(searchTranslations);

type PropertyTypeRadioOptions = {
    options: FilterOptions;
    onPropertyTypeChange: (evt: ChangeEvent<HTMLInputElement>) => void;
    propertyType: string | string[];
};

const PropertyTypeRadioButtons: FC<PropertyTypeRadioOptions> = ({
    options,
    onPropertyTypeChange,
    propertyType
}) => {
    return (
        <>
            {options?.map((option) => {
                const { label, value } = option;

                const idKey = `mobile_property_type_option${
                    value ? `_${value}` : '_all'
                }`;

                const hasSelectedThisPropertyType = propertyType === value;

                return (
                    <PropertyTypeRadio key={`${value}-${label}`}>
                        <StyledRadio
                            key={`${value}-${label}`}
                            id={idKey}
                            data-testid={value}
                            name="propertyTypeOption"
                            label={label}
                            value={value}
                            checked={hasSelectedThisPropertyType}
                            onChange={onPropertyTypeChange}
                        />
                    </PropertyTypeRadio>
                );
            })}
        </>
    );
};

export const SelectPropertyType: FC = () => {
    const reduxDispatch = useDispatch();
    const {
        selectedValue: propertyTypeSelectedValue,
        options: propertyTypeOptions
    } = useSelector(propertyTypeSelector);

    const onPropertyTypeChange = (evt: ChangeEvent<HTMLInputElement>) => {
        reduxDispatch(updateFilter('propertyType', evt.currentTarget.value));
    };

    const propertyTypeLabel = t('filters.field.property_type_label.label');

    return (
        <FilterWrapper>
            <PropertyTypeFilterLabel htmlFor="modal-property-type-filter">
                {propertyTypeLabel}
            </PropertyTypeFilterLabel>
            <PropertyTypeRadioButtonWrapper>
                <PropertyTypeRadioButtons
                    onPropertyTypeChange={onPropertyTypeChange}
                    propertyType={propertyTypeSelectedValue}
                    options={propertyTypeOptions}
                />
            </PropertyTypeRadioButtonWrapper>
        </FilterWrapper>
    );
};
